export default __webpack_public_path__ + "static/media/08_Business-ProductArchitecture-InteriorEschweilerPhotography_M1A7702_2_3.a2638666.jpg";